module.exports = __webpack_public_path__ + "static/ALLEGATO32-692298fc8d02d5519b563955f17ebb12.pdf";